import { parseNumericLastSelectedId } from "@/lib/pagination/scrollPageUrl";
import { NotificationsApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";
import type { NotificationFiltersState } from "@/features/notifications/shared/notificationFilters";
import { usesUnreadNotificationsEndpoint } from "@/features/notifications/shared/notificationFilters";

export const NOTIFICATIONS_SCROLL_PAGE_SIZE = 30;

export interface ScrollNotificationsParams {
  userId: number;
  page: number;
  pageSize?: number;
  lastSelectedId?: string | number;
  filters: NotificationFiltersState;
}

export async function scrollNotifications(
  accessToken: string,
  {
    userId,
    page,
    pageSize = NOTIFICATIONS_SCROLL_PAGE_SIZE,
    lastSelectedId,
    filters,
  }: ScrollNotificationsParams,
) {
  const service = createAuthenticatedApi(NotificationsApi, accessToken);
  const cursor = parseNumericLastSelectedId(lastSelectedId);

  if (usesUnreadNotificationsEndpoint(filters)) {
    return service.apiNotificationsUserIdUnreadGet({
      userId,
      page,
      pageSize,
      lastSelectedId: cursor,
    });
  }

  return service.apiNotificationsUserIdGet({
    userId,
    page,
    pageSize,
    lastSelectedId: cursor,
  });
}
